import { type AnalyticsClient } from './AnalyticsClient';

export let analyticsClient: AnalyticsClient = undefined as any;

export const useAnalytics = (): AnalyticsClient => analyticsClient;

export const setAnalyticsClient = (client: AnalyticsClient) => {
  analyticsClient = client;
};
